import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { WFInicioFirma, WFInicioFirmaCatalogos, WFInicioFirmaGuardar } from './types'

const endpoint = 'wf-inicio-firma'

export const HttpWFInicioFirma = {
    getBySistema: (sinCodSistema: number, bitSoloActivos: boolean): Promise<WFInicioFirma[]> =>
        HttpAxiosRequest.getWithQueryParams(endpoint, { sinCodSistema, bitSoloActivos }),

    getCatalogos: (sinCodSistema: number): Promise<WFInicioFirmaCatalogos> =>
        HttpAxiosRequest.get(`${endpoint}/${sinCodSistema}/catalogos`),

    create: (sinCodSistema: number, data: WFInicioFirmaGuardar): Promise<{ intIdWFInicioFirma: number }> =>
        HttpAxiosRequest.post(`${endpoint}/${sinCodSistema}`, data),

    update: (sinCodSistema: number, id: number, data: WFInicioFirmaGuardar): Promise<void> =>
        HttpAxiosRequest.put(`${endpoint}/${sinCodSistema}/${id}`, data),

    deactivate: (id: number): Promise<void> =>
        HttpAxiosRequest.delete(`${endpoint}/${id}`)
}
